(function () {
  var STORAGE_KEY = 'tm_recently_viewed_v1';
  var MAX_STORED = 12;
  var MAX_SHOWN = 8;

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function writeStore(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }

  function trackCurrentProduct() {
    var dataEl = document.querySelector('[data-tm-current-product]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!product || !product.handle) return;

    var list = readStore().filter(function (p) { return p.handle !== product.handle; });
    list.unshift(product);
    writeStore(list);
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var amount = (cents / 100).toFixed(0);
    return '₹' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildCard(product) {
    var el = document.createElement('a');
    el.className = 'tm-recent-card';
    el.href = product.url;

    var priceHtml = '<span class="tm-recent-card__price">' + formatMoney(product.price) + '</span>';
    if (product.compareAtPrice && product.compareAtPrice > product.price) {
      priceHtml += '<span class="tm-recent-card__compare">' + formatMoney(product.compareAtPrice) + '</span>';
    }

    var safeTitle = (product.title || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

    el.innerHTML =
      '<span class="tm-recent-card__img-wrap">' +
        '<img src="' + product.image + '" alt="' + safeTitle + '" loading="lazy" width="260" height="260">' +
      '</span>' +
      '<span class="tm-recent-card__title">' + safeTitle + '</span>' +
      '<span class="tm-recent-card__price-row">' + priceHtml + '</span>';

    return el;
  }

  function render() {
    var section = document.querySelector('[data-tm-recently-viewed]');
    if (!section) return;
    var list = section.querySelector('[data-tm-recent-list]');
    if (!list) return;

    var currentHandle = section.getAttribute('data-current-handle') || '';
    var items = readStore().filter(function (p) { return p.handle !== currentHandle; }).slice(0, MAX_SHOWN);

    if (items.length < 2) {
      section.hidden = true;
      return;
    }

    list.innerHTML = '';
    items.forEach(function (product) {
      list.appendChild(buildCard(product));
    });
    section.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    trackCurrentProduct();
    render();
  });
})();
